export const QUICKBI_PANEL_KEYS = {
  SELF_SERVICE_ANALYSIS: 'selfServiceAnalysis',
  SELF_SERVICE_DOWNLOAD: 'selfServiceDownload',
  XIAO_Q_REPORT: 'xiaoQReport',
  XIAO_Q_QUERY: 'xiaoQQuery',
}

export const QUICKBI_ROUTE_TO_PANEL = {
  selfServiceAnalysisEmbed: QUICKBI_PANEL_KEYS.SELF_SERVICE_ANALYSIS,
  selfServiceDownloadEmbed: QUICKBI_PANEL_KEYS.SELF_SERVICE_DOWNLOAD,
  xiaoQEmbedReport: QUICKBI_PANEL_KEYS.XIAO_Q_REPORT,
  xiaoQQueryEmbed: QUICKBI_PANEL_KEYS.XIAO_Q_QUERY,
}

export const QUICKBI_PANEL_ROUTES = Object.keys(QUICKBI_ROUTE_TO_PANEL)

export function getQuickBIPanelKeyByRoute(route) {
  if (!route || !route.name) {
    return null
  }
  return QUICKBI_ROUTE_TO_PANEL[route.name] || null
}

export function isQuickBIPanelRoute(route) {
  return !!getQuickBIPanelKeyByRoute(route)
}

export function createInitialMountedMap() {
  return {
    [QUICKBI_PANEL_KEYS.SELF_SERVICE_ANALYSIS]: false,
    [QUICKBI_PANEL_KEYS.SELF_SERVICE_DOWNLOAD]: false,
    [QUICKBI_PANEL_KEYS.XIAO_Q_REPORT]: false,
    [QUICKBI_PANEL_KEYS.XIAO_Q_QUERY]: false,
  }
}
